export const DASHBOARD_DETAIL_HEADER = [
  '일시',
  '사고다발지역',
  '국가지점번호',
  '다목적위치표지판번호',
  '배터리1',
  '배터리2',
  '배터리3',
  '배터리 교체 횟수',
  '온도',
  '습도',
  'GNSS-경도',
  'GNSS-위도',
  '기울기',
  '충격',
  '데시벨',
];
export const SENSOR_DATA_HEADER = [
  '일시',
  '국가지점번호',
  '다목적위치표지판번호',
  'GNSS-경도',
  'GNSS-위도',
  '온도',
  '습도',
  '기울기',
  '충격',
  '소리',
  '배터리1',
  '배터리2',
  '배터리3',
  'Use-Power',
  'GNSS-경도 레벨',
  'GNSS-위도 레벨',
  '온도 레벨',
  '습도 레벨',
  '기울기 레벨',
  '충격 레벨',
  '소리 레벨',
  '배터리1 레벨',
  '배터리2 레벨',
  '배터리3 레벨',
];
export const SENSOR_STATISTICS_HEADER = [
  '일시',
  '배터리1',
  '배터리1 알람',
  '배터리1 교체',
  '배터리2',
  '배터리2 알람',
  '배터리2 교체',
  '배터리3',
  '배터리3 알람',
  '배터리3 교체',
  '온도',
  '온도 알람',
  '습도',
  '습도 알람',
  'GNSS-위도',
  'GNSS-경도',
  'GNSS-위도 기준값',
  'GNSS-경도 기준값',
  'GNSS 알람',
  '기울기',
  '기울기 알람',
  '소리',
  '소리 알람',
  '충격',
  '충격 알람'
];